const s = (t, r, e = "") => {
  if (e === "un")
    return t;
  const o = (t * r).toString().match(/^\d+(?:\.\d{0,2})?/);
  return Number(o);
}, u = (t) => t.toLocaleString("pt-br", { style: "currency", currency: "BRL" }), m = (t) => Number(t.toString().match(/^\d+(?:\.\d{0,2})?/)), d = (t, r, e) => {
  const n = r * 1e3 * e;
  return t === "un" ? `${e} ${e > 1 ? "unidades" : "unidade"} ` : n >= 1e3 ? `${n / 1e3}kg` : `${n}g`;
}, a = (t, r) => {
  const e = r * 1e3;
  return t === "un" ? "" : e >= 1e3 ? `/${e / 1e3}kg` : `/${e}g`;
}, i = (t, r) => {
  const e = r == null ? void 0 : r.filter(
    (n) => t.includes(n.field.originalName) && n.values.some((c) => c.originalName.toLowerCase() === "true")
  );
  return (e == null ? void 0 : e.map((n) => n.field.originalName)) || [];
}, f = (t) => i([
  "Vegano",
  "Orgânico",
  "Sem Glúten",
  "Sem Lactose",
  "Sem Açúcar"
], t);
export {
  u as formatBrazilianPrice,
  f as formatEspecifications,
  s as formatListPrice,
  a as formatedMultiply,
  d as formatedQty,
  m as truncPrice
};
